"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SegmentedControl = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./SegmentedControl.css");
var _useIconButtonStyles = require("../buttons/useIconButtonStyles");
var _Icon = require("../icons/Icon");
var _focus = require("../styles/focus");
var _scale = require("../styles/scale");
var _system = require("../system");
var _tokens = require("../tokens");
var _textStyles = require("../typography/textStyles");
var _linaria = require("../utils/linaria");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable @typescript-eslint/no-use-before-define */

function SegmentedControlInternal(props, ref) {
  const type = props.type,
    options = props.options,
    block = props.block,
    disabled = props.disabled,
    testID = props.testID,
    onChange = props.onChange;
  const _useState = (0, _react.useState)(props.value),
    selectedValue = _useState[0],
    setSelectedValue = _useState[1];
  const name = (0, _react.useId)();
  const heightVar = (0, _useIconButtonStyles.useIconButtonStyles)();
  const vars = Object.assign({
    '--width': block ? '100%' : 'max-content'
  }, heightVar);
  const size = type === 'icon' ? props.iconSize : 'l';
  const handleChange = (0, _react.useCallback)(e => {
    setSelectedValue(e.target.value);
    onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value);
  }, [onChange]);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: containerStyle,
    style: vars
  }, options.map(({
    label,
    value,
    accessibilityLabel
  }) => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: value
  }, /*#__PURE__*/_react.default.createElement("input", {
    "aria-label": accessibilityLabel,
    checked: selectedValue === value,
    className: (0, _linaria.cx)(radioStyle, _focus.insetFocusRing),
    "data-testid": testID ? `${testID}-${value}` : undefined,
    disabled: disabled,
    id: `${name}-${value}`,
    name: name,
    onChange: handleChange,
    type: "radio",
    value: value
  }), /*#__PURE__*/_react.default.createElement(_system.Interactable, {
    as: "label",
    background: "backgroundAlternate",
    className: labelStyle,
    disabled: disabled,
    htmlFor: `${name}-${value}`
  }, /*#__PURE__*/_react.default.createElement(Label, {
    hidden: true,
    iconSize: size,
    option: label,
    type: type
  }), /*#__PURE__*/_react.default.createElement(Label, {
    iconSize: size,
    option: label,
    type: type
  })))));
}
function Label({
  type,
  option,
  iconSize,
  hidden
}) {
  return /*#__PURE__*/_react.default.createElement("span", {
    "aria-hidden": hidden,
    className: (0, _linaria.cx)(optionStyle, hidden && hiddenLabel)
  }, type === 'icon' ? /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    color: "currentColor",
    name: option,
    size: iconSize
  }) : option, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: "checkmark",
    size: "xs"
  }));
}
// This is a bit risky, but more ideal than a fixed px value
const CHECKMARK_SIZE = _scale.xSmallVariables['--label2-font-size'];
const containerStyle = "cds-containerStyle-c12klco7";
const labelStyle = "cds-labelStyle-l1kgnxl7";
const hiddenLabel = "cds-hiddenLabel-hndsv2o";
const optionStyle = "cds-optionStyle-o858etv";
const radioStyle = "cds-radioStyle-r1pjwlcw";
const SegmentedControl = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(SegmentedControlInternal));
exports.SegmentedControl = SegmentedControl;
SegmentedControl.displayName = 'SegmentedControl';